<template>
  <div class="listview">
    <table>
      <thead class="none">
        <tr>
          <td class="listview__title items">NAME</td>
          <td class="listview__title placement">REMARK</td>
          <td class="listview__title dailyvisitor">COLLECTION</td>
          <td class="listview__title price">ADDED TO PAGE</td>
          <td class="listview__title price">VISIBILITY</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index" @click.stop="listClick(item)" class="content">
          <td class="items">
            <div class="item">
              <div class="stack">
                <span class="title">{{item.title}}</span>
                <span class="location">
                  {{item.layout_display}}
                </span>
              </div>
            </div>
          </td>
          <td class="placement none"><span>{{item.remarks}}</span></td>
          <td class="visitor none"><span>{{item.item_count}} item</span></td>
          <td class="visitor none"><span>{{collectionList(item.page_list)}}</span></td>
          <td class="visibilty-action">
            <div class="visibilty-action__wrapper">
              <div class="visibility">
                <adx-selectdropdown :itemId="item.id" @selected="selectedVisibility" :value="item.status" :label="`Visibility`" :options="dropdown" />
              </div>
              <div class="menuExpansion">
                <menu-expansion :itemID="item.id" @selected="selected" :lists="menuList" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <slot name="infiniteLoading"/>
    </table>
    <div class="emptyState">
      <adx-empty-selection v-if="isEmpty && !isLoading" />
    </div>
    <div class="listview__loadingWrapper">
      <adx-loading v-if="isLoading" />
    </div>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import MenuExpansion from '@/components/MenuExpansion'
import EmptySelection from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'

import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-collection-list-item',
  components: {
    'adx-selectdropdown': SelectDropdown,
    'menu-expansion': MenuExpansion,
    'adx-empty-selection': EmptySelection,
    'adx-loading': Loading,
  },
  props: {
    items: {
      required: false
    },
    menuList: {
      required: false
    },
    isLoading: {
      required: false
    }
  },
  data() {
    return {
      isEmpty: false,
      dropdown: [
        {
          label: 'Public',
          value: 'Public'
        },
        {
          label: 'Private',
          value: 'Private'
        }
      ],
      hover: []
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {
    if(this.items == 0) {
      this.isEmpty = true
    }else {
      this.isEmpty = false
    }
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectedVisibility(item) {
      (async () => {
        const data = {
          id: item.id,
          visibility: item.item.value == 'Public' ? true : false
        }
        const response = await api.patch(apiV2.collectionGroupVisiblity(item.id), data, { needToken: true })
        this.$notify({
          group: 'saved',
          title: 'Update Visibility Success',
          text: `${response.data.title} has been successfully changed to ${response.data.status}`,
          type: 'success'
        })
      })();
    },
    selected(item) {
      switch(item.value) {
        case 'delete':
          (async () => {
            const response = await api.destroy(apiV2.collectionGroupDetail(item.item_id), { needToken: true })
            if (response.status === 204) {
              this.$notify({
                group: 'saved',
                title: 'Delete Success',
                text: `group has been successfully deleted`,
                type: 'success'
              });
              this.$emit('dataChanged')
            }
          })();
          break;
        case 'duplicate':
          (async () => {
            const response = await api.patch(apiV2.collectionGroupDuplicate(item.item_id), {}, { needToken: true })
            if (response.status === 201) {
              this.$notify({
                group: 'saved',
                title: 'Duplicate Success',
                text: `group has been successfully duplicated`,
                type: 'success'
              });
              this.$emit('dataChanged')
            } else {
              this.$notify({
                group: 'saved',
                title: 'Duplicate Error',
                text: response.data.message,
                type: 'danger'
              });
            }
          })();
          break;
        case 'addpage':
          (async () => {
            const body = {
              groups_id: [item.item_id]
            }
            const response = await api.post(apiV2.collectionGroupAddToPage(item.items.id), body, { needToken: true })
            if (response.status === 201) {
              this.$notify({
                group: 'saved',
                title: 'Add to Group Success',
                text: `group has been successfully added to Group`,
                type: 'success'
              });
              this.$emit('dataChanged')
              this.$emit('orderChanged')
            } else {
              this.$notify({
                group: 'saved',
                title: 'Add Error',
                text: response.data.message,
                type: 'danger'
              });
            }
          })();
          break;
        // case 'remove':
        //   (async () => {
        //     const body = {
        //       page_id: item.items.id
        //     }
        //     const response = await api.post(apiV2.collectionGroupRemovePage(item.item_id), body, { needToken: true })
        //     if (response.status === 201) {
        //       this.$notify({
        //         group: 'saved',
        //         title: 'Remove from Page Success',
        //         text: `group has been successfully removed from page`,
        //         type: 'success'
        //       });
        //       this.$emit('dataChanged')
        //     } else {
        //       this.$notify({
        //         group: 'saved',
        //         title: 'Remove Error',
        //         text: response.data.message,
        //         type: 'danger'
        //       });
        //     }
        //   })();
        //   break;
      }
    },
    collectionList(item) {
      if (item.length > 0) {
        return item.join(', ')
      } else {
        return 'None'
      }
    },
    listClick(item) {
      this.$router.push({ name: 'collectiongroupeditor', params: { id: item.id } })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>